<template>
  <div class="row">
    <ul id="explore-tabs" class="justify-content-center text-center col">
      <li class="col-lg-2 col-md-3 col-4 grey-text" id="recommended-tab">
        <router-link to="/recommended">Forslag</router-link>
      </li>
      <li class="col-lg-2 col-md-3 col-4 grey-text" id="themes-tab">
        <router-link to="/explore">Temaer</router-link>
      </li>
      <li class="col-lg-2 col-md-3 col-4 grey-text" id="alphabetic-tab">
        <router-link to="/alphabetic">A - Å</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
  #explore-tabs {
    margin-bottom: 10px;
  }
  
  #explore-tabs li {
  	display: inline-block;
  	text-align: center;
    line-height: 48px;
    height: 48px;
    padding: 0;
    margin: 0;
    text-transform: uppercase;
    letter-spacing: .8px;
    cursor: pointer;
  }

  #explore-tabs li.active {
  	border-bottom: 3px solid rgb(000,112,141);
  	color: rgb(000,112,141);
  }
</style>
